import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Debug controller connected")
    alert("Stimulus controller debugging is working!")
  }
}
